export const localeFolder = (locale) => {
    const availableFolders = ['en', 'km'];
    return availableFolders.includes(locale) ? locale : 'en';
};
